import { classNames } from '@/lib/misc/Utils'

const SPIN_SPEED = {
  slow: 'animate-spin-slow',
  normal: 'animate-spin-normal',
  fast: 'animate-spin',
}

interface LoadingSpinnerProps {
  className?: string
  spin?: boolean
  speed?: 'slow' | 'normal' | 'fast'
  lineColor?: string
  dotColor?: string
  interlinkLogo?: boolean
}

const LoadingSpinner = ({
  className,
  spin = true,
  speed = 'fast',
  lineColor = '#3f245b',
  dotColor = '#00d9ad',
  interlinkLogo = true,
}: LoadingSpinnerProps) => {
  if (!interlinkLogo) {
    return (
      <svg
        className={classNames(
          spin ? (speed ? SPIN_SPEED[speed] : SPIN_SPEED.fast) : '',
          className
        )}
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        />
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        />
      </svg>
    )
  }

  return (
    <svg
      className={classNames(
        spin ? (speed ? SPIN_SPEED[speed] : SPIN_SPEED.fast) : '',
        className
      )}
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 31.16 31.16"
    >
      <defs>
        <style>{`.cls-2{fill:${lineColor};}.cls-3{fill:${dotColor};}`}</style>
      </defs>
      <rect
        width="31.16"
        height="31.16"
        rx="2.76"
        fill="#fff"
        fillOpacity={0}
      />
      <path
        className="cls-2"
        d="M25.67,15.72a7.94,7.94,0,0,0-1-3.85A8,8,0,0,0,16.94,6a8,8,0,0,0-3.45.79h-.26a7.87,7.87,0,0,0-7.85,7.51,7.91,7.91,0,0,0-.15,1.55,8.12,8.12,0,0,0,5.49,7.67,8.1,8.1,0,0,0,10.56-.68A7.92,7.92,0,0,0,25.67,15.72ZM16.94,6.47a7.51,7.51,0,0,1,6.5,3.76A7.91,7.91,0,0,0,17.75,7.8c-.19,0-.37,0-.56,0a7.72,7.72,0,0,0-2.65-1A7.37,7.37,0,0,1,16.94,6.47ZM24.46,14a7.57,7.57,0,0,1-.75,3.25c0-.08,0-.15,0-.23A8.12,8.12,0,0,0,19.51,9.9a8.1,8.1,0,0,0-1.86-1.79h.1A7.61,7.61,0,0,1,24,11.33,7.35,7.35,0,0,1,24.46,14Zm-4.52,9a7.59,7.59,0,0,1-2.19.33,7.23,7.23,0,0,1-1.15-.1,8.2,8.2,0,0,0,2.24-1.47,8,8,0,0,0,3.64-2A7.46,7.46,0,0,1,19.94,23ZM9.88,21.72a7.84,7.84,0,0,0,3.35.76l.39,0a6.86,6.86,0,0,0,1.21.61,7.21,7.21,0,0,1-1.48.15,7.52,7.52,0,0,1-2.29-.36A8,8,0,0,1,9.88,21.72Zm-4-5.91a7.44,7.44,0,0,1,4.86-7,7.89,7.89,0,0,0-1.63,3.24A8.06,8.06,0,0,0,7.48,17a8.24,8.24,0,0,0,.77,3.43A7.72,7.72,0,0,1,6.13,17.5,7.24,7.24,0,0,1,5.93,15.81ZM14.16,7a7.7,7.7,0,0,1,2.69.85,7.62,7.62,0,0,0-1.08.2,8.06,8.06,0,0,0-2.42-.37c-.19,0-.37,0-.55,0A7.31,7.31,0,0,1,14.16,7Zm4.06,14.38A9.23,9.23,0,0,1,17,21.5a8,8,0,0,0,3.58-4.18A7.49,7.49,0,0,1,18.22,21.39ZM10.4,17.67a7.35,7.35,0,0,1-.27-2,7.56,7.56,0,0,1,2.23-5.37,7.35,7.35,0,0,1,3.24-.76,7.23,7.23,0,0,1,2.29.37,7.4,7.4,0,0,1,2.87,5.85c0,.1,0,.2,0,.3a7.7,7.7,0,0,1-4.14,5.38A7.51,7.51,0,0,1,10.4,17.67Zm5.24,4.22a7.58,7.58,0,0,1-1.79.36,7.65,7.65,0,0,1-2.68-2.71A8,8,0,0,0,15.64,21.89ZM9.53,12.76a7.61,7.61,0,0,1,2-2,7.9,7.9,0,0,0-1.73,4.93c0,.27,0,.54,0,.81A7.67,7.67,0,0,1,9.42,14,8.27,8.27,0,0,1,9.53,12.76ZM14.1,9a8.47,8.47,0,0,1,1-.44,6.85,6.85,0,0,1,1,.32c-.15,0-.31,0-.47,0A7.48,7.48,0,0,0,14.1,9Zm5.69,1.86.23.17a5.77,5.77,0,0,1,.27.56A7.25,7.25,0,0,0,19.79,10.9ZM18.22,9.34a7.87,7.87,0,0,0-1.94-1.09,6.77,6.77,0,0,1,1-.12A7.75,7.75,0,0,1,19.11,9.7,6.9,6.9,0,0,0,18.22,9.34Zm-4.87-.95a7.72,7.72,0,0,1,1.18.1,7.75,7.75,0,0,0-1.34.77A8.1,8.1,0,0,0,10,11.17a7.65,7.65,0,0,1,1.77-2.6A7.09,7.09,0,0,1,13.35,8.39ZM8.18,17a7.44,7.44,0,0,1,.75-3.23c0,.07,0,.14,0,.21a8,8,0,0,0,1.45,4.58,8,8,0,0,0,3,3.71h-.09a7.55,7.55,0,0,1-3.61-.91A7.33,7.33,0,0,1,8.18,17Zm6,5.41A7.63,7.63,0,0,0,16.05,22a8.69,8.69,0,0,0,.89.05l.52,0a7.48,7.48,0,0,1-2.11,1A7.23,7.23,0,0,1,14.14,22.42ZM19.56,21a8.09,8.09,0,0,0,1.31-8.24,7.91,7.91,0,0,0-.5-1.44,7.33,7.33,0,0,1,2.46,7.3A7.49,7.49,0,0,1,19.56,21ZM13.09,7a9,9,0,0,0-1.29.89A8.16,8.16,0,0,0,5.73,13,7.68,7.68,0,0,1,13.09,7ZM6.51,18.68a7.9,7.9,0,0,0,1.94,2.17,9.85,9.85,0,0,0,.7,1.07A7.49,7.49,0,0,1,6.51,18.68Zm9.09,5.75a7.33,7.33,0,0,1-2.73-.53l.48,0a8,8,0,0,0,2.7-.47,8,8,0,0,0,1.7.19,7.54,7.54,0,0,0,1.43-.14A7.34,7.34,0,0,1,15.6,24.43Zm6.32-2.35a8.05,8.05,0,0,0,1.66-3.6A8,8,0,0,0,25,14a7.55,7.55,0,0,0-.05-.83,7.5,7.5,0,0,1,.46,2.56A7.59,7.59,0,0,1,21.92,22.08Z"
      />
      <path
        className="cls-3"
        d="M8.3,15.06a.63.63,0,1,1,.63-.63A.63.63,0,0,1,8.3,15.06Zm.82,5.69a.45.45,0,1,0,.45.45A.45.45,0,0,0,9.12,20.75Zm8.59-.29a.37.37,0,1,0,.36.37A.37.37,0,0,0,17.71,20.46Zm6.65-4.74a.62.62,0,0,0,0,1.23.62.62,0,1,0,0-1.23Zm1.09-1.25a.46.46,0,1,0,.45.46A.45.45,0,0,0,25.45,14.47ZM8.79,8.87a.59.59,0,0,0,.6-.59.6.6,0,0,0-.6-.6.59.59,0,0,0-.59.6A.58.58,0,0,0,8.79,8.87ZM5.63,16.31a.36.36,0,0,0-.37.37.37.37,0,0,0,.37.37A.38.38,0,0,0,6,16.68.37.37,0,0,0,5.63,16.31ZM20,22.73a.64.64,0,1,0,.64.64A.64.64,0,0,0,20,22.73ZM16.44,5.85a.36.36,0,0,0-.36.37.37.37,0,1,0,.73,0A.36.36,0,0,0,16.44,5.85Z"
      />
    </svg>
  )
}

export default LoadingSpinner
